import { Component, Input } from '@angular/core';
import { AyaSourceRef } from 'src/app/core/utils/aya-sources.util';

@Component({
  selector: 'app-aya-chat-sources',
  templateUrl: './aya-chat-sources.component.html',
  styleUrls: ['./aya-chat-sources.component.scss'],
})
export class AyaChatSourcesComponent {
  @Input() sources: AyaSourceRef[] = [];
  @Input() messageId = '';

  meta(source: AyaSourceRef): string {
    return [source.journal || source.domain, source.year].filter(Boolean).join(' · ');
  }
}
